import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { CustomerFormComponent } from './customer-form/customer-form.component';
import {AppRoutingModule} from "./app-routing/app-routing.module";
import {CustomerService} from "./customer-service.service";
import {InvoiceService} from "./invoice-service.service";
import {InvoiceFormComponent} from "./invoice-form/invoice-form.component";
import {PaymentService} from "./payment-service.service";
import {PaymentListComponent} from "./payment-list/payment-list.component";
import {PaymentFormComponent} from "./payment-form/payment-form.component";
import {TriggerStatementsComponent} from "./trigger-statements/trigger-statements.component";
import {StatementsService} from "./statements-service.service";

@NgModule({
  declarations: [
    AppComponent,
    CustomerListComponent,
    InvoiceListComponent,
    PaymentListComponent,
    CustomerFormComponent,
    InvoiceFormComponent,
    PaymentFormComponent,
    TriggerStatementsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [CustomerService, InvoiceService, PaymentService, StatementsService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts